// The device passphrase form (docs/08-app-design.md 5.1 step 4), shared by
// Create and Restore. Minimum 10 characters, strength shown as a sentence.
// Both live in the entrance's frame, so the submit button wears the flat
// skin there (app/art/welcome/PLAN.md section 4.5), not the app's .button.

import { type FormEvent, useState } from 'react';
import { passphraseStrength } from '../util';
import { Field, StatusLine } from './primitives';

export function PassphraseForm({ onSubmit, busy, error, submitLabel = 'Continue' }: { onSubmit: (passphrase: string) => void; busy?: boolean; error?: string | null; submitLabel?: string }) {
  const [p1, setP1] = useState('');
  const [p2, setP2] = useState('');
  const strength = passphraseStrength(p1);
  const matches = p1 === p2;
  const ready = strength.ok && matches && !busy;
  const submit = (e: FormEvent) => {
    e.preventDefault();
    if (ready) onSubmit(p1);
  };
  return (
    <form onSubmit={submit} className="stack">
      <p className="ink">This passphrase unlocks the app on this device. It is not your 24 words and cannot recover the vault.</p>
      <Field id="passphrase" label="Device passphrase" help={strength.text}>
        <input id="passphrase" className="input" type="password" autoComplete="new-password" value={p1} onChange={(e) => setP1(e.target.value)} disabled={busy} autoFocus aria-describedby={strength.text ? 'passphrase-help' : undefined} />
      </Field>
      <Field id="passphrase2" label="Repeat it" help={p2 && !matches ? 'The two entries differ.' : undefined}>
        <input id="passphrase2" className="input" type="password" autoComplete="new-password" value={p2} onChange={(e) => setP2(e.target.value)} disabled={busy} aria-invalid={p2 && !matches ? 'true' : 'false'} aria-describedby={p2 && !matches ? 'passphrase2-help' : undefined} />
      </Field>
      {error ? (
        <StatusLine state="failed" word="Not saved.">
          {error}
        </StatusLine>
      ) : null}
      <div className="actions">
        <button type="submit" className="cta cta-mint" disabled={!ready} aria-busy={busy ? 'true' : undefined}>
          {busy ? 'Sealing' : submitLabel}
        </button>
      </div>
    </form>
  );
}
